import React, {lazy} from 'react';
import {SettingDefinition} from '../../../../shared/account-settings/actions/notification-settings';

const AccountSettings = lazy(() => import('src/components/ChecklistStudentAccountSettings'));

const NOTIFICATION_SETTINGS: SettingDefinition[] = [
  {
    setting: 'How to use Raise Me',
    topic: 'howToAndAccountCompletion',
    text: 'Learn how to utilize Raise Me on your college journey and to reach your full earning potential.',
  },
  {
    setting: 'Scholarship updates',
    topic: 'scholarshipUpdates',
    text: 'Scholarships can open up at any time. Stay up to date.',
  },
  {
    setting: 'Critical deadline reminders',
    topic: 'criticalDeadlineReminders',
    text: 'Not recommended to unsubscribe. These notifications are critical for submissions deadlines to colleges.',
  },
];

export const AdultLearnerAccountSettings = (): React.ReactElement => (
  <AccountSettings availableNotificationSettings={NOTIFICATION_SETTINGS} />
);
